import { NgForm } from '@angular/forms';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UsuarioService } from '../services/service.index';
import { Usuario } from '../models/usuario.model';
import swal2 from 'sweetalert2';
import { environment } from '../../environments/environment';

declare function init_plugins();

// Componente de login para cliente Unita - 16/07/2025
@Component({
  selector: 'app-loginunita',
  templateUrl: './loginunita.component.html',
  styleUrls: ['./loginunita.component.css']
})
export class LoginUnitaComponent implements OnInit {

  showPassword = false;
  email: string;
  recuerdame = false;
  recuperacont = false;
  auth2: any;
  usuarios: any[] = [];
  imagen: string;

  constructor(
    public router: Router,
    public _usuarioService: UsuarioService
  ) { }

  async ngOnInit() {
    init_plugins();
    this.imagen = environment.CLIENTE;
    this.email = localStorage.getItem('email') || '';
    if (this.email.length > 1) {
      this.recuerdame = true;
    }
  }

  recuperarcont() {
    this.recuperacont = !this.recuperacont;
  }

  // Método de ingreso para Unita - 16/07/2025
  ingresar(forma: NgForm) {
    swal2.fire('Espere, por favor');
    swal2.showLoading();
    if (forma.invalid) {
      return;
    }
    const usuario = new Usuario(null, forma.value.email, forma.value.password);
    this._usuarioService.login(usuario, forma.value.recuerdame)
      .subscribe(correcto => {
        localStorage.setItem('quiensoy', 'unita');
        setTimeout(() => {
          this.router.navigate(['/dashboard']);
          swal2.close();
        }, 1000);
      }, (err) => {
        swal2.fire(
          'Error al Acceder',
          'Revise su información',
          'error'
        );
      });
  }

  // Envía correo de recuperación de contraseña - 16/07/2025
  enviacrecuperacion() {
    const email = (document.getElementById('emailrec') as HTMLInputElement).value;
    this._usuarioService.getResetPaswword(email).subscribe(resp => {
      this.recuperacont = !this.recuperacont;
      swal2.fire(
        'El correo de recuperación de contraseña fue enviado a:',
        email,
        'success'
      );
    }, (err) => {
      console.log(err);
      swal2.fire(
        'Error',
        err.error.errors[0],
        'error'
      );
    });
  }

}
